var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-button',{attrs:{"type":"default"},on:{"click":_vm.submit}},[_vm._v("提交")]),_c('AccountInfoPopup',{ref:"aip",on:{"success":_vm.accountInfoOk}}),_c('AuthInfo',{ref:"aui",on:{"ok":_vm.authInfoOk,"cancel":_vm.authCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }